import { useRecoilValue } from "recoil";
import { localizationAtom } from "recoil/localizationAtom";

export default function usePriceAmount() {
  const locale = useRecoilValue(localizationAtom);

  const priceAmount_original = locale.includes("ko") ? "80,000" : "59.99";
  const priceAmount_discount = locale.includes("ko") ? "40,000" : "59.99";

  return {
    priceAmount_original,
    priceAmount_discount,
  };
}
